<template>
    <div class="grade-wrapper">
        <div class="class-type">
            <el-card class="box-card low-class" @click.native="classCategories = lowCategories"
                :class="{ selected: classCategories == lowCategories }">
                <div class="group-title">
                    <div class="group-img">
                        <img src="../../assets/image/low_student.png" mode="scaleToFill" />
                    </div>

                    <span>小初高</span>
                </div>
            </el-card>
            <el-card class="box-card high-class" :class="{ selected: classCategories == highCategories }"
                @click.native="classCategories = highCategories">
                <div class="group-title">
                    <div class="group-img">
                        <img src="../../assets/image/high_student.png" />
                    </div>

                    <span>大学·职场</span>
                </div>
            </el-card>
        </div>
        <div class="class-category">
            <div v-for="(item, index) in classCategories" :key="index" class="category-item">
                <div class="category-title">
                    {{ item.title }}
                </div>
                <div class="category-list">
                    <div v-for="(category, index) in item.categories" :key="index" class="category-name"
                        :class="{ empty: category.name === ' ', active: selectedGrade === category.name || selectedGrade.startsWith(category.name) }"
                        @click="handleGradeClick(category)">
                        {{ category.name }}
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex/dist/vuex.common.js';

export default {
    name: 'grade',
    data() {
        return {
            classCategories: [],
            lowCategories: [],
            highCategories: [],
            selectedGrade: "",
        }
    },
    computed:{
        ...mapState(["user"])

    },
    created() {
        this.initCategories();

    },
    mounted() {
        this.selectedGrade = this.user.grade;
        // lifecycle hook
    },
    methods: {

        handleGradeClick(category) {

            this.selectedGrade = category.name
            this.$emit("setGrade", this.selectedGrade)

        },
        initCategories() {
            this.lowCategories = [
                {
                    title: "小学",
                    categories: [
                        { name: "一年级", id: "1", isClick: false },
                        { name: "二年级", id: "2", isClick: false },
                        { name: "三年级", id: "3", isClick: false },
                        { name: "四年级", id: "4", isClick: false },
                        { name: "五年级", id: "5", isClick: false },
                        { name: "六年级", id: "6", isClick: false },
                    ],
                },
                {
                    title: "初中",
                    categories: [
                        { name: "七年级", id: "7", isClick: false },
                        { name: "八年级", id: "8", isClick: false },
                        { name: "九年级", id: "9", isClick: false },
                    ],
                },
                {
                    title: "高中",
                    categories: [
                        { name: "高一", id: "10", isClick: false },
                        { name: "高二", id: "11", isClick: false },
                        { name: "高三", id: "12", isClick: false },
                        { name: "职高一", id: "13", isClick: false },
                        { name: "职高二", id: "14", isClick: false },
                        { name: "职高三", id: "15", isClick: false },
                        { name: "中专一", id: "16", isClick: false },
                        { name: "中专二", id: "17", isClick: false },
                        { name: "中专三", id: "18", isClick: false },
                    ],
                },
            ];
            this.highCategories = [
                {
                    title: "大学",
                    categories: [
                        { name: "大一", id: "19", isClick: false },
                        { name: "大二", id: "20", isClick: false },
                        { name: "大三", id: "21", isClick: false },
                        { name: "大四", id: "22", isClick: false },
                        { name: "大五", id: "23", isClick: false },
                        { name: "研一", id: "24", isClick: false },
                        { name: "研二", id: "25", isClick: false },
                        { name: "研三", id: "26", isClick: false },
                        { name: " ", id: "30", isClick: false },
                    ],
                },
                {
                    title: "职场",
                    categories: [
                        { name: "教师", id: "27", isClick: false },
                        { name: "家长", id: "28", isClick: false },
                        { name: " ", id: "31", isClick: false },
                    ],
                },
            ];
            this.classCategories = this.lowCategories;
        },
    }
}
</script>

<style lang="scss" scoped>
.grade-wrapper {
    font-size: 14px;
    .class-type {
        display: flex;
        align-items: center;
        justify-content: center;

        .el-card {
            width: 200px;
            border-radius: 8px;
            border: 1px solid var(--border-page);
            font-weight: 700;
            cursor: pointer;
            color: var(--txt-default-color);
            background-color: var(--leftbox-bg-color);

            &:hover,
            &.selected {
                color: var(--txt-hover-color);
                background-color: var(--hover-bg-color-2, #434346);
            }

            .group-title {
                display: flex;
                align-items: center;
                justify-content: center;

                .group-img {
                    margin-right: 10px;
                }
            }
        }

        .low-class {
            margin-right: 10px;
        }
    }

    // 年级分组 小学、初中...

    .class-category {
        color: var(--txt-default-color);
       
        .category-title {
            margin: 20px 0;
            width: 100%;
            font-weight: 600;
            font-size: 14px;
        }

        .category-list {
            display: flex;
            flex-wrap: wrap;

            .category-name {
                margin-right: 15px;
                margin-bottom: 10px;
                width: 150px;
                text-align: center;
                line-height: 36px;
                border-radius: 18px;
                background-color: var(--hover-bg-color-1);
                border: 1px solid transparent;
                cursor: pointer;

                &:nth-child(3n) {
                    margin-right: 0 !important;
                }

                &:hover,
                &.active,
                &.selected {
                    color: var(--txt-hover-color);
                    border: 1px solid var(--txt-hover-color);
                    background-color: var(--hover-bg-color-2);
                }

                &.empty {
                    cursor: default;
                    opacity: 0;
                }
            }
        }
    }

}

</style>